<template>
  <div 
    class="mt-5 lg:mt-0 w-full"
  >

    <campaign-event-display :campaign-id="campaignId" />

    <div 
      class="bg-white mb-5" 
      @click.prevent="openModal(campaignCard)" 
      v-for="campaignCard in campaignCards"
    >

      <div v-if="campaignCard.type == `ad`" @click="openLink(campaignCard.link)" class="bg-center bg-no-repeat bg-cover h-40" :style="`background-image: url(`+campaignCard.image+`) !important;`" ></div>
      <div v-else @click="isOpen = !isOpen" class="bg-center bg-no-repeat bg-cover h-40 flex justify-center cursor-pointer rounded-t-lg" :style="`background-image: url(`+campaignCard.image+`) !important;`">
        <div class="flex justify-center items-center">
          <i class="text-2xl fas fa-play bg-black bg-opacity-75 px-6 py-4 text-white hover:bg-white hover:text-black"></i>
        </div>
      </div>

      <div class="px-8 pb-8 pt-6 border border-gray-200 rounded-b-lg">
        <h3  v-if="campaignCard.type == `ad`" @click="openLink(campaignCard.link)" class="text-md font-bold mb-5 leading-tight">{{campaignCard.title}}</h3>
        <h3  v-else class="text-md font-bold mb-5 leading-tight"><a :href="campaignCard.link" target="_blank" style="color:#000;">{{campaignCard.title}}</a></h3>

        <p class="text-sm">{{campaignCard.description}}</p>

        <a v-if="campaignCard.type == `ad`"  href="#" @click="openLink(campaignCard.link)" class="mx-5 mt-5 flex justify-center py-3 px-4 border border-transparent shadow-sm text-sm font-medium text-white bg-pink-500 hover:bg-pink-700 focus:outline-none  focus:ring-offset-2 focus:ring-indigo-500 uppercase">{{campaignCard.button_name}}</a>
<!--        <a v-else @click="isOpen = !isOpen" class="mx-5 mt-5 flex justify-center py-3 px-4 border border-transparent shadow-sm text-sm font-medium text-white bg-pink-500 hover:bg-pink-700 focus:outline-none  focus:ring-pink-200 uppercase">Learn More</a>-->

      </div>

    </div>

    <transition
        enter-class="transition ease-out duration-0 transform"
        enter-active-class="opacity-0"
        enter-to-class="opacity-100"
        leave-class="transition ease-in duration-0 transform"
        leave-active-class="opacity-100"
        leave-to-class="opacity-0"
    >
    <div v-if="this.isOpen"  class="fixed z-20 inset-0 overflow-y-auto">
      <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div class="fixed inset-0 transition-opacity" aria-hidden="true">
          <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>

        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
        <div class="inline-block align-bottom text-left shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-3xl sm:w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
          <div class="sm:flex sm:items-start">
            <div class="text-center sm:mt-0 sm:text-left w-full">
              <div class="flex justify-between items-center pb-3">
                <div class="modal-close cursor-pointer z-50 absolute top-0 right-0 bg-pink rounded-full flex items-center justify-center text-2xl block p-2 custom-close">
                  <svg @click="isOpen = false" class="fill-current text-white" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path></svg>
                </div>
              </div>
              <div class="aspect-w-16 aspect-h-9">
                <iframe :src="selectedCampaignCardLink" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </div>
              <div class="min-w-full p-3 bg-white text-center lg:text-left">
                <div class="flex flex-col lg:flex-row items-center px-5">
                  <div class="lg:w-9/12">
                    <p class="text-lg">Inspiring hope in the fight against stage IV breast cancer</p>
                  </div>
                  <div class="lg:w-3/12">
                    <a href="#" class="mx-16 mt-2 lg:mx-0 lg:mt-0 flex justify-center py-3 px-5 lg:px-1 border border-transparent shadow-sm text-sm font-medium text-white bg-pink-500 hover:bg-pink-700 focus:outline-none  focus:ring-offset-2 focus:ring-indigo-500 uppercase inline-block">Donate Now</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </transition>


  </div>

</template>

<script>
    import CampaignEventDisplay from "../events/CampaignEventDisplay"

    export default {
      name: 'HighlightedBlogPosts',

      props: {
        campaignId: {
          type: String,
          required: true,
        },

        campaign: {
          type: Object,
          required: false,
        },
      },

      components: {
        CampaignEventDisplay,
      },

      data() {
        return {
          youtubeIdInView: '',
          isOpen: false,
          modalIsOpen: false,
          selectedCampaignCard: {},
        }
      },
      methods: {
        openModal(campaignCard) {
          this.selectedCampaignCard = campaignCard
          this.modalIsOpen = true

          this.captureClick(campaignCard)
        },

        closeModal() {
          this.youtubeIdInView = ''
          this.modalIsOpen = false
        },
        captureClick(campaignCard) {
          axios.post('/campaign-card-click', {'campaign_card_id': campaignCard.id, 'campaign_id': this.campaignId})
              .then(response => {
                //console.log('here')
              })
        },
        openLink: function (link, target = '_blank') {
          window.open(link, target);
        }
      },
      computed: {
        campaignCards() {
          return this.campaign ? this.campaign.campaign_cards : []
        },
        selectedCampaignCardLink() {
          return this.selectedCampaignCard ? this.selectedCampaignCard.link : null
        },
      },

    }
</script>

<style scoped>
.aside-impact .img {
  background: url('/img/impact-yt-img.jpg') no-repeat center center;
  background-size: cover;
}
</style>
